import { Button, ButtonGroup, ButtonProps, MenuProps, Tooltip, TooltipProps } from '@material-ui/core';
import React from 'react';

import { MoreOptionsMenu } from './MoreOptionsMenu';

export type SplitButtonOption = {
  onClick: () => void;
  label: React.ReactNode;
};

interface Props extends Omit<ButtonProps, 'onClick'> {
  options: SplitButtonOption[];
  menuProps?: Partial<MenuProps>;
  tooltipProps?: Omit<TooltipProps, 'children'>;
}

export const SplitButtonMenu = ({ tooltipProps, ...otherProps }: Props): React.ReactElement => {
  if (tooltipProps != null) {
    return (
      <Tooltip {...tooltipProps}>
        <span>
          <SplitButtonMenuWithoutTooltip {...otherProps} />
        </span>
      </Tooltip>
    );
  } else {
    return <SplitButtonMenuWithoutTooltip {...otherProps} />;
  }
};

export const SplitButtonMenuWithoutTooltip = ({
  options,
  menuProps,
  ...buttonProps
}: Omit<Props, 'tooltipProps'>): React.ReactElement => {
  const [first, ...rest] = options;

  if (first == null) {
    throw new Error(`Options must contain at least 1 element: options=${JSON.stringify(options)}`);
  }

  if (rest.length === 0) {
    return (
      <Button onClick={first.onClick} {...buttonProps}>
        {first.label}
      </Button>
    );
  } else {
    const { disabled, color } = buttonProps;

    return (
      <ButtonGroup disabled={disabled} color={color}>
        <Button onClick={first.onClick} {...buttonProps}>
          {first.label}
        </Button>
        <MoreOptionsMenu id={'more-options'} options={rest} menuProps={menuProps} Button={Button} {...buttonProps} />
      </ButtonGroup>
    );
  }
};
